import React from "react";
import { Box, Typography, Container } from "@mui/material";

function TermsOfService() {
  const DARK_NAVY = "#0A192F";
  const LIGHT_GRAY = "#B0BEC5";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        py: { xs: 6, md: 10 },
        backgroundColor: DARK_NAVY,
        color: "white",
      }}
    >
      <Container maxWidth="md">
        <Typography variant="h4" gutterBottom sx={{ textAlign: "center" }}>
          Terms of Service
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: LIGHT_GRAY, mb: 4, textAlign: "center" }}
        >
          These Terms of Service (“Terms”) govern your use of the Arocoiris
          Technology Private Limited platform. By accessing our services, you
          agree to these Terms in accordance with the Indian Contract Act, 1872
          and the Consumer Protection Act, 2019.
        </Typography>

        <Section title=" Use of the Platform" color={LIGHT_GRAY}>
          You agree to use the platform lawfully and not engage in:
          <br />• Unauthorized access
          <br />• Data scraping or misuse
          <br />• Activities violating Indian cyber laws
        </Section>

        <Section title=" User Responsibilities" color={LIGHT_GRAY}>
          You are responsible for maintaining the confidentiality of your
          account and ensuring accurate information is provided.
        </Section>

        <Section title=" Intellectual Property" color={LIGHT_GRAY}>
          All content, trademarks, and code belong to Arocoiris Tech.
          Unauthorized reproduction or distribution is prohibited under the
          Copyright Act, 1957.
        </Section>

        <Section title=" Limitation of Liability" color={LIGHT_GRAY}>
          We are not liable for indirect, incidental, or consequential damages
          arising from the use of our platform, as permitted under Indian law.
        </Section>

        <Section title=" Termination" color={LIGHT_GRAY}>
          We may suspend or terminate access for violations of these Terms or
          misuse of the platform.
        </Section>

        <Section title=" Governing Law" color={LIGHT_GRAY}>
          These Terms are governed by the laws of India. Any disputes shall be
          subject to the jurisdiction of courts in Uttar Pradesh.
        </Section>

        <Section title=" Contact Us" color={LIGHT_GRAY}>
          For any queries regarding these Terms, contact:
          <br />
          Email: support@arocoristechnology.com
        </Section>
      </Container>
    </Box>
  );
}

function Section({ title, children, color }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ color: "white", mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body1" sx={{ color }}>
        {children}
      </Typography>
    </Box>
  );
}

export default TermsOfService;
